import React, { Component } from 'react';
import { connect } from 'react-redux'
import { change as changeFieldValue } from 'redux-form';
import 'moment/locale/pt-br'
import '../../css/components/react-datepicker.css';
import pt from 'date-fns/locale/pt';
import Titulo from '../comum/Titulo';
import Autorizacao from '../../security/Autorizacao';
import {
    PERFIL_ADMIN
} from '../../security/securityContext';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import DatePicker from 'react-datepicker/es';
import AbaPendenteRepasse from './AbaPendenteRepasse';
import AbaNaoEmbarcado from './AbaNaoEmbarcado';
import AbaHistoricoRepasse from './AbaHistoricoRepasse';
import buscarRepasseVendaSite from '../../actions/repasse-venda/buscarRepasseVendaSite';
import { tipoRepasseVenda } from '../../util/constantsUtil';
import { Field, reduxForm } from 'redux-form';
import { renderFieldSelect } from '../../util/inputs';
import limparRepasseVenda from '../../actions/repasse-venda/limparRepasseVenda';
import ModalRepasseVenda from './ModalRepasseVenda';
import { abaRepasseVenda } from '../../util/constantsUtil';
import selecionaParametrosBuscaRepasse from '../../actions/repasse-venda/selecionaParametrosBuscaRepasse';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';
import $ from 'jquery';

registerLocale('pt', pt);
setDefaultLocale('pt');

const TIPO_REPASSE_VENDA = [
    {
        descricao: 'Empresa',
        nome: 'EMPRESA'
    },
    {
        descricao: 'Vendedor',
        nome: 'VENDEDOR'
    },
    {
        descricao: 'Imposto',
        nome: 'IMPOSTO'
    }
];

export class PainelGerenciarRepasseVenda extends Component {
    constructor(props) {
        super(props);
        this.state = {
            abaRepasseVendaSelecionada: abaRepasseVenda.pendenteRepasse,
            dataInicio: null,
            dataFim: null,
            tipo: tipoRepasseVenda.empresa.nome,
            repasseVendaSelecionado: null
        };
    }

    componentDidMount() {
        this.limparCampos();        
        this.props.limparRepasseVenda();

        if (this.props.parametrosBuscaRepasseSelecionado.dataInicio) {                
            this.preencherCamposSelecionadosNaBusca();
            this.props.buscarRepasseVendaSite(this.props.parametrosBuscaRepasseSelecionado.dataInicio, this.props.parametrosBuscaRepasseSelecionado.dataFim, this.props.parametrosBuscaRepasseSelecionado.tipo, this.props.parametrosBuscaRepasseSelecionado.aba);
        } else {            
            this.props.selecionaParametrosBuscaRepasse({ dataInicio: null, dataFim: null, tipo: tipoRepasseVenda.empresa.nome, aba: abaRepasseVenda.pendenteRepasse });
            this.props.buscarRepasseVendaSite();
        }      
    }

    preencherCamposSelecionadosNaBusca() {
        this.setState({ dataInicio: this.props.parametrosBuscaRepasseSelecionado.dataInicio, dataFim: this.props.parametrosBuscaRepasseSelecionado.dataFim, tipo:  this.props.parametrosBuscaRepasseSelecionado.tipo, abaRepasseVendaSelecionada: this.props.parametrosBuscaRepasseSelecionado.aba });
        this.props.changeFieldValue('formRepasseVenda','tipo',  {label: capitalizarTodasPrimeirasLetras(this.props.parametrosBuscaRepasseSelecionado.tipo), value: this.props.parametrosBuscaRepasseSelecionado.tipo });
        var triggerEl = document.querySelector(`#myTab a[href="#${this.props.parametrosBuscaRepasseSelecionado.aba}"]`)        
        $(triggerEl).tab('show')

    }

    buscar(aba) {
        this.props.selecionaParametrosBuscaRepasse({ dataInicio: this.state.dataInicio, dataFim: this.state.dataFim, tipo: this.state.tipo || this.props.parametrosBuscaRepasseSelecionado.tipo, aba: aba || this.state.abaRepasseVendaSelecionada});


        if(aba) {
            this.props.buscarRepasseVendaSite(this.state.dataInicio, this.state.dataFim, this.state.tipo, aba);   
        } else {
            this.props.buscarRepasseVendaSite(this.state.dataInicio, this.state.dataFim, this.state.tipo, this.state.abaRepasseVendaSelecionada)
        }
    }

    limparCampos() {
        this.props.reset('formRepasseVenda');
    }

    handleSelecionarAbaRepasseVenda(aba) {
        this.setState({ abaRepasseVendaSelecionada: aba });
        this.buscar(aba)                
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <div className="container-padrao" style={{ height: '100%' }}>
                    <Titulo texto="Repasse de Venda" urlRetorno="/gestao" />
                    <fieldset className='border col-12 justify-content-center fitro-repasse-venda' style={{ backgroundColor: '#FFF' }}>
                        <div className='row mt-5 mb-5'>
                        {this.state.abaRepasseVendaSelecionada === 'HISTORICO' ?
                            <div className='col-md-3 col-12 col-sm-12'>
                                <span className="label-data">De</span>
                                <DatePicker
                                    value={this.state.dataInicio}
                                    className='form-control form-control-lg campo-busca data-itinerario'
                                    locale="pt-BR"
                                    onChange={date => {
                                        this.setState({ dataInicio: date });
                                        this.props.limparRepasseVenda();
                                    }}
                                    selected={this.state.dataInicio}
                                    dateFormat="dd/MM/yyyy" />
                                    
                            </div>  : '' }
                            {this.state.abaRepasseVendaSelecionada === 'HISTORICO' ?
                            <div className='col-md-3 col-12 col-sm-12'>
                                <span className="label-data ">Até</span>
                                <DatePicker
                                    className='form-control form-control-lg campo-busca data-itinerario'
                                    locale="pt-BR"
                                    value={this.state.dataFim}
                                    selected={this.state.dataFim}
                                    onChange={date => {
                                        this.setState({ dataFim: date });
                                        this.props.limparRepasseVenda();
                                    }}
                                    dateFormat="dd/MM/yyyy" />
                            </div>   : '' }
                            <div className='col-md-4 col-12 col-sm-12'>
                                <span className="label-data ">Tipos de repasse:</span>
                                <div className='mt-1'>
                                    <Field name='tipo'                                        
                                        options={TIPO_REPASSE_VENDA}
                                        onChange={event => {                                            
                                            this.setState({ tipo: event.value })
                                            this.props.limparRepasseVenda();
                                        }}
                                        component={renderFieldSelect}
                                        placeholder='Selecione...'/>
                                </div>
                            </div>
                            <div className='col-md-2 col-12 col-sm-12 mt-4 d-flex align-items-center'>
                                <span className="label-data"> </span>
                                <button disabled={this.state.abaRepasseVendaSelecionada === 'HISTORICO' ? !this.state.dataInicio || !this.state.dataFim || !this.state.tipo : !this.state.tipo} type="submit"
                                    onClick={() => this.buscar()} className="btn btn-laranja">
                                    Buscar
                                </button>
                            </div>
                        </div>
                    </fieldset>

                    <div className="lista-table mt-5 aba-repasse-venda">
                        <ul className="nav nav-tabs" id="myTab" role="tablist">
                            <li className="nav-item">
                                <a className="nav-link active" id="pendenteRepasse-tab" data-toggle="tab" href="#PENDENTE" role="tab" aria-controls="pendenteRepasse" aria-selected="true" onClick={() => this.handleSelecionarAbaRepasseVenda(abaRepasseVenda.pendenteRepasse)}>Pendente de repasse</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="profile-tab" data-toggle="tab" href="#NAO_EMBARCADO" role="tab" aria-controls="profile" aria-selected="false" onClick={() => this.handleSelecionarAbaRepasseVenda(abaRepasseVenda.naoEmbarcado)}>Não embarcadas</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="contact-tab" data-toggle="tab" href="#HISTORICO" role="tab" aria-controls="contact" aria-selected="false" onClick={() => this.handleSelecionarAbaRepasseVenda(abaRepasseVenda.historicoRepasse)}>Histórico de repasse</a>
                            </li>
                        </ul>
                        <div className="tab-content" id="myTabContent" style={{ padding: '25px 5px' }}>
                            <div className="tab-pane fade  show active" id="PENDENTE" role="tabpanel" aria-labelledby="pendenteRepasse-tab">
                                <AbaPendenteRepasse tipoRepasseVenda={this.state.tipo} abaRepasseVendaSelecionada={this.state.abaRepasseVendaSelecionada}/>
                            </div>
                            <div className="tab-pane fade" id="NAO_EMBARCADO" role="tabpanel" aria-labelledby="profile-tab">
                                <AbaNaoEmbarcado tipoRepasseVenda={this.state.tipo} abaRepasseVendaSelecionada={this.state.abaRepasseVendaSelecionada} />
                            </div>
                            <div className="tab-pane fade" id="HISTORICO" role="tabpanel" aria-labelledby="contact-tab">
                                <AbaHistoricoRepasse tipoRepasseVenda={this.state.tipo} abaRepasseVendaSelecionada={this.state.abaRepasseVendaSelecionada} />
                            </div>
                        </div>
                    </div>
                    <ModalRepasseVenda repasseVendaSelecionado={this.state.repasseVendaSelecionado}  abaRepasseVendaSelecionada={this.state.abaRepasseVendaSelecionada} tipoRepasseVenda={this.state.tipo} dataInicio={this.state.dataInicio} dataFim={this.state.dataFim} history={this.props.history}/>
                </div>
            </Autorizacao>
        )
    }
}


export const mapStateToProps = (state) => {    
    return {
        repasseVenda: state.repasseVenda,
        repasseVendaSelecionado: state.repasseVendaSelecionado,
        parametrosBuscaRepasseSelecionado: state.parametrosBuscaRepasseSelecionado        
    }
};

export default connect(mapStateToProps, {
    changeFieldValue,
    buscarRepasseVendaSite,
    limparRepasseVenda,
    selecionaParametrosBuscaRepasse
})(reduxForm({
    form: 'formRepasseVenda',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
})(PainelGerenciarRepasseVenda));
